export default "__VITE_ASSET__D1n_K55V__"